export  default {

    state: () => ({
        organization: null,
        organizationStats: null,
    }),

    getters: {

        getterOrganization(state){
            return state.organization
        },

        getterOrganizationStats(state){
            return state.organizationStats
        },

    },

    mutations: {

        setOrganization(state, data){
            state.organization = data
        },

        setOrganizationStats(state, data){
            state.organizationStats = data
        },

    },

    actions: {

        getOrganization( {dispatch,commit} , {idx, stats = false}){
            axios.get(`/api/organizations/${idx}`)
                .then(response => {
                    response = response.data

                    if(response.success){

                        commit('setOrganization', response.data)
                        if(stats) dispatch('getOrganizationStats', idx)
                    }

                })
                .catch(error => {
                    error = error.response.data

                    if(!error.success) console.log(error)

                })
        },

        getOrganizationStats({commit}, idx){
            axios.get(`/api/organizations/${idx}/stats`)
                .then(response => {
                    response = response.data

                    if(response.success){

                        commit('setOrganizationStats', response.data)
                    }

                })
                .catch(error => {
                    error = error.response.data

                    if(!error.success) console.log(error)

                })
        },

    },

}
